import { render, staticRenderFns } from "./StrongLabel.vue?vue&type=template&id=dc0d41b6"
import script from "./StrongLabel.vue?vue&type=script&lang=js"
export * from "./StrongLabel.vue?vue&type=script&lang=js"
import style0 from "./StrongLabel.vue?vue&type=style&index=0&id=dc0d41b6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports